<script lang="ts">
  // "Ask for these items". It creates no order and carries no price — it asks, and the
  // company answers with a priced cart. That is what keeps the rule that this client
  // never states a price.
  //
  // The caption is ours. The company placed this button; we say what it does.

  import { t } from '$lib/i18n/index.svelte';

  import type { ElementContext } from '../context';
  import type { CardState } from './card-state.svelte';

  let { ctx, card }: { ctx: ElementContext; card: CardState } = $props();

  const chosen = $derived(card.chosen());
  let sent = $state(0);

  function send(): void {
    const items = card.chosen();
    if (items.length === 0) {
      return;
    }
    ctx.onRequestItems(items);
    sent = items.length;
    // The request is in the thread now, so the card starts clean. Leaving the numbers
    // sitting there would invite a second, accidental send of the same list.
    card.clear();
  }
</script>

<button
  class="submit"
  type="button"
  disabled={ctx.disabled || chosen.length === 0}
  onclick={send}
>
  {t('views.control.requestItems')}
</button>
{#if sent > 0}
  <span class="sent" role="status">{t('views.requestSent', { count: sent })}</span>
{/if}

<style>
  .submit {
    border: 1px solid var(--line);
    border-radius: 10px;
    background: var(--surface);
    color: var(--ink);
    font: inherit;
    font-weight: 600;
    padding: 10px 16px;
    cursor: pointer;
  }
  .submit:disabled {
    opacity: 0.5;
    cursor: default;
  }
  .sent {
    margin-left: 10px;
    font-size: 13px;
    color: var(--ink-soft);
  }
</style>
